import React, {PureComponent} from 'react';

import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {SectionedSearchDropdown} from 'components/controls';
import {fetchDiagnosesForDropdown} from 'reducers/diagnoses/diagnosesActions';
import {fetchPatientProblemsForDropdown} from 'reducers/problems/problemsActions';
import {noop} from 'components/helpers/funcTools';

// XXX: watch out for this function. a possible bottleneck and just poor practice generally.
const excludeDuplicateDiagnoses = (diagnoses, problems) => {
    return diagnoses.filter((diagnosis) => {
        // !Array.some(predicate) pretty much means Array.none(predicate)
        // and checks if exactly zero elements pass the test.
        return !problems.some(
            (problem) => `${problem.diagnosis.id}${problem.diagnosis.name}` === `${diagnosis.id}${diagnosis.name}`
        );
    })
};

const defaultGetKey = (item) => item.id;
const defaultGetLabel = (item) => item.name;

const createDropdownSection = (
    name,
    options,
    extraFields,
    accessors = {},
) => {
    const section = {
        name,
        options,
        ...extraFields,
    };

    if (!accessors.getKey) accessors.getKey = defaultGetKey;
    if (!accessors.getLabel) accessors.getLabel = defaultGetLabel;
    if (!accessors.getOptionKey) accessors.getOptionKey = defaultGetKey;
    if (!accessors.getOptionLabel) accessors.getOptionLabel = defaultGetLabel;

    accessors.getKey = accessors.getKey.bind(this, section);
    accessors.getLabel = accessors.getLabel.bind(this, section);

    return {
        ...section,
        ...accessors,
    }
};

class ProblemAndDiagnosisSearchContainer extends PureComponent {
    static propTypes = {
        fetchDiagnoses: PropTypes.func.isRequired,
        fetchProblems: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        onClear: PropTypes.func,
        diagnoses: PropTypes.array,
        problems: PropTypes.array,
        patientId: PropTypes.string.isRequired,
        error: PropTypes.string,
        label: PropTypes.string,
        areDiagnosesProcessing: PropTypes.bool,
        areProblemsProcessing: PropTypes.bool,
        initialDiagnosis: PropTypes.object,
        // this stuff is needed to juggle the format mess we've created. we better think of something better later.
        shouldUnfoldProblemDiagnosisToOnChange: PropTypes.bool,
        searchDelaySeconds: PropTypes.number,
    };

    static defaultProps = {
      onClear: noop,
      diagnoses: [],
      problems: [],
      areDiagnosesProcessing: false,
      areProblemsProcessing: false,
      shouldUnfoldProblemDiagnosisToOnChange: true,
      label: '',
      searchDelaySeconds: 0.5,
      initialDiagnosis: null,
    };


    state = {
        search: '',
        selectedOption: null,
        selectedSection: null,
    };

    constructor(props) {
        super(props);
        const {searchDelaySeconds} = props;

        // lodash accepts milliseconds in it's debounce() method
        const searchDelay = searchDelaySeconds * 1000;

        this.handleSearch = _.debounce(this.handleSearch, searchDelay);
    }

    componentDidMount() {
        const {fetchProblems, patientId, value} = this.props;
        const initialDiagnosis = this.props.initialDiagnosis || !_.isEmpty(value) && value;

        if (initialDiagnosis) {
            this.setState({
                selectedOption: initialDiagnosis,
                selectedSection: createDropdownSection(
                    'bullshit',
                    [],
                    {},
                    {
                        getOptionLabel: (item) => `${item.id} ${item.name}`
                    }
                )
            })
        }
        fetchProblems(patientId);
    }


    handleSelect = (section, option) => {
        const { onChange, shouldUnfoldProblemDiagnosisToOnChange } = this.props;
        this.setState({selectedOption: option, selectedSection: section});

        let optionToReturn = Object.assign({}, option);
        if (shouldUnfoldProblemDiagnosisToOnChange && option && option.diagnosis) {
            optionToReturn.name = optionToReturn.diagnosis.name;
            optionToReturn.id = optionToReturn.diagnosis.id;
            delete optionToReturn.diagnosis;
        }

        onChange({target: {value: optionToReturn}});
    };

    handleSearch = (search) => {
        const {patientId, fetchDiagnoses, fetchProblems} = this.props;

        if (search === '') fetchProblems(patientId, {filter: {search}});
        this.setState({search});
        fetchDiagnoses(search);
        fetchProblems(patientId, {filter: {search}});
    };


    render() {
        const {
            problems,
            diagnoses,
            areDiagnosesProcessing,
            areProblemsProcessing,
            error,
            label,
            onClear,
            selectedOptionClassname
        } = this.props;
        const {search, selectedOption, selectedSection} = this.state;

        const isLoading = areProblemsProcessing || areDiagnosesProcessing;

        const sections = [
            createDropdownSection(
                loc('diagnosis-dropdown-problems'),
                problems,
                {id: 'problems'},
                {
                    getOptionKey: (item) => item.diagnosis.id,
                    getOptionLabel: (item) => `${item.diagnosis.id} ${item.diagnosis.name}`,
                }),
            createDropdownSection(
                loc('diagnosis-dropdown-other'),
                excludeDuplicateDiagnoses(diagnoses, problems),
                {order: 2, id: 'diagnoses'},
                {getOptionLabel: (item) => `${item.id} ${item.name}`}),
        ];

        return (
            <SectionedSearchDropdown
            isLoading={isLoading}
            selectedOption={selectedOption}
            selectedSection={selectedSection}
            selectedOptionClassname={selectedOptionClassname}
            sections={sections}
            onSelect={this.handleSelect}
            onSearch={this.handleSearch}
            onClear={onClear}
            label={label}
            search={search}
            error={error}/>
        );
    }
}

const mapStateToProps = (state) => {
    const {diagnosis, problems} = state;

    // for whatever reason these can end up undefined. initial state doesn't get set or some shit.
    const problemList = _.get(problems, 'dropdownList.list', []);
    const diagnosisList = _.get(diagnosis, 'dropdownList', []);

    const diagnosesError = _.get(diagnosis, 'dropdownListError', '');
    const problemsError = _.get(problems, 'dropdownListError', '');

    return {
        diagnoses: diagnosisList,
        areDiagnosesProcessing: diagnosis.dropdownListProcessing,
        diagnosesError: diagnosesError,
        problems: problemList,
        areProblemsProcessing: problems.dropdownListProcessing,
        problemsError: problemsError,
    }
};

const mapDispatchToProps = {
    fetchDiagnoses: fetchDiagnosesForDropdown,
    fetchProblems: fetchPatientProblemsForDropdown,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProblemAndDiagnosisSearchContainer);



// WEBPACK FOOTER //
// ./src/components/controls/ProblemAndDiagnosisSearchContainer.jsx